export default __webpack_public_path__ + "static/lframe-loans-d51da884e8ecbd2f20fe54c1dbc25052.png";